export const INTRO_STAGES = Object.freeze([
  { name: "match", duration: 3000 },
  { name: "teamA", duration: 3500 },
  { name: "teamB", duration: 3500 },
  { name: "toss", duration: 3000 },
  { name: "striker", duration: 3000 },
  { name: "nonStriker", duration: 3000 },
  { name: "bowler", duration: 4000 }
]);

export const INTRO_TOTAL_MS = INTRO_STAGES.reduce((sum, stage) => sum + stage.duration, 0);

export function introStageAt(elapsedMs) {
  if (!Number.isFinite(elapsedMs) || elapsedMs < 0 || elapsedMs >= INTRO_TOTAL_MS) return null;
  let start = 0;
  for (const stage of INTRO_STAGES) {
    const end = start + stage.duration;
    if (elapsedMs < end) {
      return { ...stage, start, end, elapsed: elapsedMs - start, progress: (elapsedMs - start) / stage.duration };
    }
    start = end;
  }
  return null;
}

export function validateIntroPayload(payload) {
  if (!payload || typeof payload !== "object") return { ok: false, error: "Intro payload missing" };
  if (!payload.sequenceId || !payload.matchId || !payload.venue) return { ok: false, error: "Intro identity incomplete" };
  for (const key of ["teamA", "teamB"]) {
    const team = payload[key];
    if (!team?.name || !Array.isArray(team.players) || team.players.length < 2) return { ok: false, error: `${key} incomplete` };
  }
  if (!payload.toss?.winner || !payload.toss?.choice) return { ok: false, error: "Toss incomplete" };
  if (!payload.striker || !payload.nonStriker || !payload.bowler?.name) return { ok: false, error: "Opening players incomplete" };
  return { ok: true, value: JSON.parse(JSON.stringify(payload)) };
}

export function buildIntroPayload(match, venue, metaResolver, sequenceId = `intro-${Date.now()}`) {
  if (!match?.toss || !match.toss.winner) return null;
  const innings = match?.innings?.[0];
  const metaA = metaResolver?.(match?.teamA?.name) || {};
  const metaB = metaResolver?.(match?.teamB?.name) || {};
  const winnerTeam = match.toss.winner === "A" ? match.teamA : match.teamB;
  const payload = {
    sequenceId,
    matchId: match?.id,
    venue: venue || "Venue",
    overs: match?.overs,
    teamA: { name: match?.teamA?.name, players: [...(match?.teamA?.players || [])], captain: match?.teamA?.captain || match?.teamA?.players?.[0] || "", color: metaA.color || "#0a7d28", logo: metaA.logo || null },
    teamB: { name: match?.teamB?.name, players: [...(match?.teamB?.players || [])], captain: match?.teamB?.captain || match?.teamB?.players?.[0] || "", color: metaB.color || "#dc2626", logo: metaB.logo || null },
    toss: { winner: winnerTeam?.name || "", choice: match?.toss?.choice === "bat" ? "BAT" : "BOWL" },
    striker: innings?.currentStriker || "",
    nonStriker: innings?.currentNonStriker || "",
    bowler: { name: innings?.currentBowler || "" }
  };
  return payload;
}
